import { render, staticRenderFns } from "./SMarksup.vue?vue&type=template&id=02c0b574&scoped=true"
import script from "./SMarksup.vue?vue&type=script&lang=js"
export * from "./SMarksup.vue?vue&type=script&lang=js"
import style0 from "./SMarksup.vue?vue&type=style&index=0&id=02c0b574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c0b574",
  null
  
)

export default component.exports